export default __webpack_public_path__ + "static/ico-air-97205fd3e3e4d5aa0586ab52105ff298.svg";